import { useEffect } from 'react';
import './TwistHistory.scss';
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { getTwistHistory, getVlTwistHistory, getVlTwistsByRare } from '../../api/twist';
import { getCardImage } from '../../funcs/card';
import { IMAGES } from '../../assets/media/images';
import Empty from '../loading/Empty';

function TwistHistory({ elRef }) {
    const limit = 100;

    const {data: vlTwists} = useQuery({
        queryKey: ["vlTwistHistory"],
        queryFn: getVlTwistHistory,
    })

    const {data: vlTwistsRare} = useQuery({
        queryKey: ["vlTwistsRare"],
        queryFn: getVlTwistsByRare,
    })

    const {data, fetchNextPage, hasNextPage, isFetchingNextPage} = useInfiniteQuery({
        queryKey: ["twistHistory"],
        queryFn: ({ pageParam = 0 }) => getTwistHistory({ limit: limit, offset: pageParam*limit }),
        getNextPageParam: (lastPage, allPages) => {
            if (!lastPage) return undefined;
            return lastPage.length === limit ? allPages.length : undefined;
        },
    })

    useEffect(() => {
        if (!elRef.current) return;
        const handleScroll = (e) => {
            const el = e.target;
            if (el.scrollHeight - el.scrollTop - el.clientHeight < 200 && hasNextPage && !isFetchingNextPage) {
                fetchNextPage();
            };
        };

        const el = elRef.current;
        el.addEventListener("scroll", handleScroll);
        return function () {
            el.removeEventListener("scroll", handleScroll);
        };
    }, [elRef, fetchNextPage, hasNextPage, isFetchingNextPage])

    const twists = data ? data.pages.flat() : [];
    const formattedTwists = twists.map(twist => ({
        ...twist,
        get_date: new Date(twist.get_date).toLocaleString("ru-RU", {
            year: "numeric",
            month: "long",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        })
    }))

    return (
        vlTwists === 0 ? <Empty /> : <div className='twist-wrapper'>
            <div className='vl-twist-container'>
                <span className='vl-twist-text'>Откручено круток:</span>
                {vlTwistsRare && <div className='vl-twist-wrapper'>
                    <div className='vl-twist'>
                        <img src={IMAGES.common} alt='card' />
                        <span>{vlTwistsRare.filter(twist => twist.rare === "Обычная").map(twist => twist.count)}</span>
                    </div>

                    <div className='vl-twist'>
                        <img src={IMAGES.rare} alt='card' />
                        <span>{vlTwistsRare.filter(twist => twist.rare === "Редкая").map(twist => twist.count)}</span>
                    </div>

                    <div className='vl-twist'>
                        <img src={IMAGES.epic} alt='card' />
                        <span>{vlTwistsRare.filter(twist => twist.rare === "Эпическая").map(twist => twist.count)}</span>
                    </div>

                    <div className='vl-twist'>
                        <img src={IMAGES.legendary} alt='card' />
                        <span>{vlTwistsRare.filter(twist => twist.rare === "Легендарная").map(twist => twist.count)}</span>
                    </div>
                    
                    <div className='vl-twist'>
                        <img src={IMAGES.mythical_puzzle} alt='card' />
                        <span>{vlTwistsRare.filter(twist => twist.rare === "Мифическая").map(twist => twist.count)}</span>
                    </div>
                </div>}
            </div>

            {formattedTwists && formattedTwists.map((twist, idx) => 
                <div key={twist.id} className={'twist' + (idx % 2 === 0 ? " dark" : "")}>
                    <div className={'twist-num '}>
                        <img src={getCardImage(twist.rare)} alt='card' />
                        {vlTwists - idx}
                    </div>
                    <div className='twist-text'>
                        <div className='twist-name'>{twist.name}</div>
                        <div className='twist-date'>{twist.get_date}</div>
                    </div>
                </div>)
            }

            {isFetchingNextPage && <div className='twist loading'>Загрузка...</div>}
        </div>
    )
};

export default TwistHistory;